import { useEffect, useState } from "react";
import { Wallet } from "lucide-react";
import { toast } from "sonner";
import { papi, errText, money } from "./portalApi";

const monthLabel = (m) => new Date(`${m}-01T00:00:00`).toLocaleString("en-GB", { month: "short", year: "numeric" });

const Stat = ({ label, value, tone = "", testid }) => (
  <div className="min-w-0">
    <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">{label}</div>
    <div className={`truncate text-base font-bold md:text-lg ${tone}`} data-testid={testid}>{value}</div>
  </div>
);

export const PortalBalance = ({ reloadKey }) => {
  const [month, setMonth] = useState("");
  const [b, setB] = useState(null);
  useEffect(() => {
    papi("get", `/balance${month ? `?month=${month}` : ""}`).then(setB).catch((e) => toast.error(errText(e)));
  }, [month, reloadKey]);
  if (!b) return null;
  return (
    <div className="rounded-2xl border bg-white p-4" data-testid="portal-balance-card">
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <Wallet className="h-4 w-4 text-teal-600" /><b className="text-sm">My balance</b>
        <span className="text-xs text-slate-400">live parcels only · INR</span>
        <select value={month} onChange={(e) => setMonth(e.target.value)} className="ml-auto rounded-lg border px-2 py-1 text-xs" data-testid="portal-balance-month">
          <option value="">All time</option>
          {b.months.map((m) => <option key={m} value={m}>{monthLabel(m)}</option>)}
        </select>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-6">
        <Stat label="Parcels" value={b.parcels} testid="portal-bal-parcels" />
        <Stat label="Products" value={money(b.products, "INR")} testid="portal-bal-products" />
        <Stat label="Shipping" value={money(b.shipping, "INR")} testid="portal-bal-shipping" />
        <Stat label="Grand total" value={money(b.grand, "INR")} testid="portal-bal-grand" />
        <Stat label="Payments" value={money(b.payments, "INR")} tone="text-emerald-700" testid="portal-bal-payments" />
        <Stat label="Balance due" value={money(b.balance, "INR")} tone={b.balance > 0 ? "text-rose-600" : "text-emerald-700"} testid="portal-bal-due" />
      </div>
    </div>
  );
};
